import React from 'react';
import User from '../user/user';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const Container = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 3fr'
}));

const DialogBox = styled('div')({
    marginBottom: '20px'
});

const DialogBody = styled('div')(({ theme }) => ({
    position: 'relative',
    padding: '5px',
    backgroundColor: theme.colors.bgLighterColor,
    borderRadius: '5px',
    border: `5px solid ${theme.colors.bgLighterColor}`
}));

const Tip = styled('span')(({ theme }) => ({
    width: '0',
    height: '0',
    position: 'absolute',
    background: 'transparent',
    border: `10px solid ${theme.colors.bgLighterColor}`,
    top: '5px',
    left: '-25px',
    borderTopColor: 'transparent',
    borderLeftColor: 'transparent',
    borderBottomColor: 'transparent'
}));

const BodyMessage = styled('div')(({ theme }) => ({
    color: theme.colors.bgColor
}));

const Time = styled(Typography)({
    float: 'right'
});

function Comment({ comment, user }) {

    return (
        <Container>
            <User user={user} />

            <DialogBox>
                <DialogBody>
                    <Tip>&nbsp;</Tip>
                    <BodyMessage>
                        <span>{comment.description}</span>
                    </BodyMessage>
                </DialogBody>
                <Time>
                    {comment.time.split('T')[0]} &nbsp;{comment.time.split('T')[1].substring(0, 5)}
                </Time>
            </DialogBox>
        </Container>
    );
}

export default Comment;
